import { combineReducers } from "redux";
import { userReducer } from "./userReducer";
import { roleGroupReducer } from "./roleGroupReducer";
import { PersonalSummaryReducer } from "./PersonalSummaryReducer";
import { PlannedMaintenanceDetailReducer } from "./PlannedMaintenanceDetailReducer";
import { userGroupReducer } from "./userGroupReducer";
import { equipmentReducer } from "./EquipmentReducer";
import { equipmentNotesReducer } from "./EquipmentNotesReducer";
import { pmReducer } from "./PMReducer";
import { amReducer } from "./AMReducer";
import { breakDownTasksReducer } from "./BreakDownTasksReducer";
import { notificationReducer } from "./notificationReducer";
import { layoutReducer } from "./layoutReducer";
import { PlannedMaintenanceCalendarReducer } from "./PlannedMaintenanceCalendarReducer";
import { breakDownDetailReducer } from "./BreakDownDetailReducer";
import { PlannedMaintenanceListReducer } from "./PlannedMaintenanceListReducer";
import { AutonomousMaintenanceCalendarReducer } from "./AutonomousMaintenanceCalendarReducer";
import { AutonomousMaintenanceListReducer } from "./AutonomousMaintenanceListReducer";
import { AutonomousMaintenanceDetailReducer } from "./AutonomousMaintenanceDetailReducer";
import { CheckItemGroupReducer } from "./CheckItemGroupReducer";
import { operatorMainPageReducer } from "./OperatorMainPageReducer";
import { operatorRequestReducer } from "./OperatorRequestReducer";
import { poolReducer } from "./PoolReducer";
import { generalTableReducer } from "./GeneralTableReducer";
import { ReportBreakDownReducer } from "./ReportBreakDownReducer";
import { breakDownListTableReducer } from "./BreakdownListTableReducer";
import { AutonomousMaintenanceOrderTaskReducer } from "./AutonomousMaintenanceOrderTasksReducer";
import { MasterDataReducers } from "./MasterDataReducers";
import { OrderFormReducer } from "./OrderFormReducer";
import { MailGroupsReducer } from "./MailGroupsReducer";
import { SnackbarReducer } from "./SnackbarReducer";
import { BackdropReducer } from "./BackdropReducer";
import { TechnicianMainPageReducer } from "./TechnicianMainPageReducer";
import { LocalizationDataReducer } from "./LocalizationDataReducer";
import { CheckItemGroupExcelReducer } from "./CheckItemGroupExcelReducer";
import { CreateMultiplePMReducer } from "./CreateMultiplePMReducer";
import { PlannedMaintenanceUpdate } from "./PlannedMaintenanceUpdateReducer";
import { ToBePlannedReducer } from "./ToBePlannedReducer";
import { SingleMaintenanceUpdate } from "./SingleMaintenanceUpdateReducer";
import { EkedEquipmentReducer } from "./EkedEquipmentReducer";
import { BreakdownReasonPlaceReducer } from "./BreakdownReasonPlaceReducer";
import { BreakdownReasonDetailReducer } from "./BreakdownReasonDetailReducer";
import { MaintenanceTypeReducer } from "./MaintenanceTypeReducer";
import { BreakdownEffectReducer } from "./BreakdownEffectReducer";
import { breakdownReasonGroupReducer } from "./BreakdownReasonGroupReducer";
import { MachineMaintenanceSummaryListReducer } from "./MachineMaintenanceSummaryListReducer";
import {MachineMaintenanceSummaryListPlannedReducer} from "./MachineMaintenanceSummaryListPlannedReducer";
import { plantReducer } from "./PlantReducer";
import { ShiftReducer } from "./ShiftReducer";
import { ShiftPlansReducer } from "./ShiftPlansReducer";
import { equipmentReportReducer } from "./EquipmentReportReducer";
import { customListReducer } from "./CustomListReducer";
import { SparePartReducer } from "./SparePartReducer";
import {SparePartExcelReducer} from "./SparePartExcelReducer";
import { ewoReducer } from "./EwoReducer";
import { rootCauseFamilyAndOptionsReducer } from "./RootCauseFamilyAndOptionsReducer";

const rootReducer = combineReducers({
    user: userReducer,
    roleGroup: roleGroupReducer,
    PersonalSummary: PersonalSummaryReducer,
    UserGroup: userGroupReducer,
    equipment: equipmentReducer,
    equipmentNotesReducer: equipmentNotesReducer,
    pm: pmReducer,
    am: amReducer,
    breakDownTask: breakDownTasksReducer,
    notification: notificationReducer,
    layout: layoutReducer,
    pool: poolReducer,
    PlannedMaintenanceCalendar: PlannedMaintenanceCalendarReducer,
    PlannedMaintenanceDetail: PlannedMaintenanceDetailReducer,
    PlannedMaintenanceList: PlannedMaintenanceListReducer,
    AutonomousMaintenanceCalendar: AutonomousMaintenanceCalendarReducer,
    AutonomousMaintenanceDetail: AutonomousMaintenanceDetailReducer,
    AutonomousMaintenanceList: AutonomousMaintenanceListReducer,
    AutonomousMaintenanceOrderTask: AutonomousMaintenanceOrderTaskReducer,
    CheckItemGroup: CheckItemGroupReducer,
    operatorPage: operatorMainPageReducer,
    operatorRequest: operatorRequestReducer,
    generalTable: generalTableReducer,
    ReportBreakDown: ReportBreakDownReducer,
    breakDownDetail: breakDownDetailReducer,
    breakDownListTable: breakDownListTableReducer,
    MasterData: MasterDataReducers,
    OrderForm: OrderFormReducer,
    MailGroups: MailGroupsReducer,
    snackbar: SnackbarReducer,
    backdrop: BackdropReducer,
    TechnicianMainPage: TechnicianMainPageReducer,
    LocalizationData: LocalizationDataReducer,
    CheckItemGroupExcel: CheckItemGroupExcelReducer,
    CreateMultiplePM: CreateMultiplePMReducer,
    PlannedMaintenanceUpdateReducer: PlannedMaintenanceUpdate,
    ToBePlanned: ToBePlannedReducer,
    SingleMaintenanceUpdateReducer: SingleMaintenanceUpdate,
    EkedEquipment: EkedEquipmentReducer,
    BreakdownReasonPlace: BreakdownReasonPlaceReducer,
    BreakdownReasonDetail: BreakdownReasonDetailReducer,
    MaintenanceType: MaintenanceTypeReducer,
    BreakdownEffect: BreakdownEffectReducer,
    BreakdownReasonGroup: breakdownReasonGroupReducer,
    MachineMaintenanceSummaryList:MachineMaintenanceSummaryListReducer,
    MachineMaintenanceSummaryListPlanned:MachineMaintenanceSummaryListPlannedReducer,
    plant: plantReducer,
    Shifts: ShiftReducer,
    ShiftPlans: ShiftPlansReducer,
    equipmentReport: equipmentReportReducer,
    customList: customListReducer,
    SparePart: SparePartReducer,
    SparePartExcel: SparePartExcelReducer,
    ewoForm: ewoReducer,
    rootCauseFamilyAndOptions: rootCauseFamilyAndOptionsReducer
});

export default rootReducer;
